import { Form, PasswordField, SubmitButton } from '@/components';
import { ResetPasswordSchema } from '@/features/tenant-manager/user/_models/user';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof ResetPasswordSchema>;

type Props = {
  onSubmit: (values: FormValues) => void;
};

export const ResetPasswordForm: FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    resolver: zodResolver(ResetPasswordSchema),
  });

  return (
    <div>
      <Form
        leavePageAlertCondition={{
          isDirty,
          isSubmitting,
          isSubmitSuccessful,
        }}
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
      >
        <PasswordField
          name="newPassword"
          label={t('new-password')}
          control={control}
          errors={errors}
          required
          showHint
        />
        <PasswordField
          name="confirmPassword"
          label={t('confirm-password')}
          control={control}
          errors={errors}
          required
        />
        <SubmitButton loading={isSubmitting} disabled={!isDirty} />
      </Form>
    </div>
  );
};
